import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog", "callButton"];

  connect() {
  }

  showModal(e) {
    const rect = e.target.getBoundingClientRect();
    const dialogRect = this.dialogTarget.getBoundingClientRect();
    this.dialogTarget.style.left = `${rect.left - (rect.width / 2) - (dialogRect.width / 2)}px`;
    this.dialogTarget.style.top = `${rect.bottom - 30}px`;
    this.dialogTarget.showModal();
  }

  closeModal(e) {
    if (e.type == "mouseout") {
      if (
        e.toElement != null && e.toElement == this.dialogTarget
      ) {
        this.dialogTarget.close();
      }
    }
    if (e.type == "click") {
      if (e.target != null && e.target == this.dialogTarget) {
        this.dialogTarget.close();
      }
    }
  }
}
